define('app-PageToggleTP/main',['./settings'], function (settings) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log("No PageToggleContainer found.  app-PageToggleTP will not be available.");
                return;
            }

            $('[data-toggle="offcanvas"]').click(function () {
                var pageHeight = $('.leftNavInner').height();
                var content = $('.innerContent').height();

                if (pageHeight > content) {
                    $('.innerContent').css({ 'min-height': pageHeight });
                }

                $('.row-offcanvas').toggleClass('active');
            });

            window.loadedModules("app-PageToggleTP");
        }
    }
});
